module.exports = __webpack_public_path__ + "img/celebration.5bce3472.svg";